interface ISharingUrl {
  name: string;
  action: string;
  url: string;
  messageParam?: string;
}

export const openShareWindow = (url: string, name: string) => {
  // FIXME: that won't work in WebView cuz of window.open
  open(url, name, 'height=520,width=570');
};

export const sharingUrls: ISharingUrl[] = [
  {
    name: 'twitter',
    action: 'Tweet',
    url: 'https://twitter.com/share?url=',
    messageParam: 'text',
  },
  {
    name: 'facebook',
    action: 'Share',
    url: 'https://www.facebook.com/sharer/sharer.php?u=',
    messageParam: 'quote',
  },
  {
    name: 'linkedin',
    action: 'Share',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  },
];
